<script lang="ts">import { onMount } from 'svelte';
import { getTracking } from '../../../../js-v2/tracking';
import { trackLinkClick } from '../../../../js-v2/trackLinkClick';
import { getEnvironmentFromHostname } from '../../../../js-v2/urlUtils';
import LogoJewel from './LogoJewel/LogoJewel.svelte';
import LogoLockup from './LogoLockup/LogoLockup.svelte';
const { id = '', title = 'Square', logo = 'LogoJewel', url = '/' } = $props();
let homeUrl = $state();
const trackFn = getTracking();
// Component map for dynamic logo selection
const logoComponents = {
    LogoJewel,
    LogoLockup,
    // Easy to add new logo in the future:
    // e.g. DeveloperLockup,
};
// Get the component based on logo prop, default to LogoJewel
const LogoComponent = logoComponents[logo] || LogoJewel;
function getHomeUrl() {
    let env;
    if (window.Sq && window.Sq.Environment) {
        env = window.Sq.Environment.env;
    }
    else {
        env = getEnvironmentFromHostname(window.location.hostname);
    }
    switch (env) {
        case 'development':
        case 'test': {
            return '/';
        }
        case 'staging': {
            return 'https://squareupstaging.com';
        }
        default: {
            return 'https://squareup.com';
        }
    }
}
onMount(() => {
    homeUrl = getHomeUrl();
});
</script>

<a class="HomeLink" data-entry-id={id} href={homeUrl} use:trackLinkClick={{ id, title, url, trackFn }}>
  <LogoComponent {title} />
</a>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.HomeLink {
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-shrink: 0;
  padding: 21px 4px;
  margin-left: 6px;
  outline: none;
  border: none;
  border-radius: 4px;
  letter-spacing: normal;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
}
.HomeLink:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}</style>
